import React from "react";
import dayjs from "dayjs";

export default function DateTimeRangePicker({
  startDateTime,
  endDateTime,
  onStartChange,
  onEndChange,
  onPresetChange,
  className = "",
    children,
}) {
  return (
    <div className={className}>
      <div className="row tbSearch">
        <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-4">
          <div className="form-group">
            <div className="form-control-wrap raw">
              <div
                className="input-daterange input-group"
                style={{ flexWrap: "nowrap" }}
              >
                <div className="form-control-wrap">
                  <div className="form-icon form-icon-left">
                    <em className="icon ni ni-calendar" />
                  </div>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={startDateTime}
                    onChange={(e) => onStartChange(e.target.value)}
                    onClick={(e) => e.target.showPicker?.()}
                  />
                </div>

                <div className="input-group-addon">~</div>

                <div className="form-control-wrap">
                  <div className="form-icon form-icon-left">
                    <em className="icon ni ni-calendar" />
                  </div>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={endDateTime}
                    onChange={(e) => onEndChange(e.target.value)}
                    onClick={(e) => e.target.showPicker?.()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
          <div className="form-group">
            <div className="form-control-wrap radio-select-day">
              <div className="custom-control custom-radio custom-control-pro no-control">
                <input
                  className="custom-control-input"
                  id="range-yesterday"
                  name="date-range"
                  type="radio"
                  onChange={() => onPresetChange?.("yesterday")}
                />
                <label
                  className="custom-control-label"
                  htmlFor="range-yesterday"
                >
                  어제
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-pro no-control">
                <input
                  className="custom-control-input"
                  id="range-today"
                  name="date-range"
                  type="radio"
                  onChange={() => onPresetChange?.("today")}
                />
                <label className="custom-control-label" htmlFor="range-today">
                  오늘
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-pro no-control">
                <input
                  className="custom-control-input"
                  id="range-week"
                  name="date-range"
                  type="radio"
                  onChange={() => onPresetChange?.("week")}
                />
                <label className="custom-control-label" htmlFor="range-week">
                  일주일
                </label>
              </div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}